import { Book as BookModel } from '../../../../models/books';
import { environment } from '../../../../environment';
import styles from './Book.module.scss';
import BookImage from '../../../../components/BookImage/BookImage';

interface BookProps {
  book: BookModel;
  style?: React.CSSProperties;
}

export const Book: React.FC<BookProps> = ({ style, book }) => {
  return(
    <section style={style} className={styles.container}>
      <div className={styles.containerImage}>
      <BookImage 
        className={styles.image} 
        path={book?.imageLink} 
        author={String(book?.author)}
        name={book?.name}
        />
      </div>
      <h1 className={styles.title}><strong>{book?.name}</strong></h1>
      <h2 style={{textAlign:'center'}}>{book?.author}</h2>
    </section>
  )
}